// CacheKey 935e413fe9b26ad46910813440dc0abe
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-COMMUNITY_HOSPITAL": {
    search: {
      echo_instructions: {
        item: "discharge instruction",
        empty: {
          summary: "No discharge instructions available",
          message: "There are no discharge instructions to display at this moment. Try reloading the page if you are expecting any updates."
        }
      }
    }
  }
}

